import { render, staticRenderFns } from "./ChoiceInput.vue?vue&type=template&id=579bdd29&scoped=true&"
import script from "./ChoiceInput.vue?vue&type=script&lang=js&"
export * from "./ChoiceInput.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceInput.vue?vue&type=style&index=0&id=579bdd29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579bdd29",
  null
  
)

export default component.exports